export default __webpack_public_path__ + "static/media/gallery_09.012ee8e1.jpg";